<template>
  <iframe :src="url"></iframe>
</template>

<script>
export default {
  name: 'HelpModal',
  props: ["url"],
  data() {
    return {

    }
  }
}
</script>

<style scoped>
iframe {
  width: 100vw;
  overflow: auto;
  position: relative;
  height: calc(100vh - 50px);
}
</style>
